import { memo } from 'react';
import { Link } from 'react-router-dom';
import SibillIcon from '~/assets/asset-company-icon.svg?react';
import styles from './SidebarLogo.module.scss';

const SidebarLogo: React.FC = () => {
  return (
    <div className={styles.container}>
      <Link to="/" className={styles.logo}>
        <SibillIcon className={styles.logo} />
      </Link>
    </div>
  );
};

export default memo(SidebarLogo);
